import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    // Generic Alert with custom buttons in footer
    alertWithFooterButtons(
        title: string,
        text: string,
        icon: 'success' | 'error' | 'warning' | 'info' | 'question' = 'info',
        buttons: { label: string, class: string, onClick: () => void }[]
    ) {
        const buttonHtml = buttons.map((btn, i) =>
            `<button id="footer-btn-${i}" class="${btn.class}" style="margin: 0 5px;">${btn.label}</button>`
        ).join('');

        Swal.fire({
            title,
            text,
            icon,
            showConfirmButton: false,
            showCancelButton: false,
            footer: `<div style="display: flex; justify-content: center;">${buttonHtml}</div>`,
            didOpen: () => {
                // Attach listeners AFTER modal is rendered
                buttons.forEach((btn, i) => {
                    const el = document.getElementById(`footer-btn-${i}`);
                    if (el) {
                        el.addEventListener('click', () => {
                            Swal.close(); // manually close
                            btn.onClick();
                        });
                    }
                });
            }
        });
    }

    //  Delete Confirmation
    confirmDelete(itemName: string, onConfirm: () => void, onCancel?: () => void) {
        this.alertWithFooterButtons(
            `Are you sure?`,
            `You want to delete ${itemName}? This action cannot be undone.`,
            'question',
            [
                {
                    label: 'Delete',
                    class: 'swal2-red-button swal2-styled',
                    onClick: onConfirm
                },
                {
                    label: 'Cancel',
                    class: 'swal2-cancel swal2-styled',
                    onClick: onCancel || (() => { })
                }
            ]
        );
    }

    //  Success
    success(message: string, callback?: () => void) {
        this.alertWithFooterButtons(
            'Success',
            message,
            'success',
            [
                {
                    label: 'OK',
                    class: 'swal2-confirm swal2-styled',
                    onClick: callback || (() => { })
                }
            ]
        );
    }

    //  Error
    error(massageTitle:string, message: string, callback?: () => void) {
        this.alertWithFooterButtons(
            massageTitle,
            message,
            'error',
            [
                {
                    label: 'OK',
                    class: 'swal2-confirm swal2-styled',
                    onClick: callback || (() => { })
                }
            ]
        );
    }

    //  Warning
    warning(message: string, callback?: () => void) {
        this.alertWithFooterButtons(
            'Warning',
            message,
            'warning',
            [
                {
                    label: 'OK',
                    class: 'swal2-confirm swal2-styled',
                    onClick: callback || (() => { })
                }
            ]
        );
    }

    //  Info
    info(title: string, message: string, callback?: () => void) {
        this.alertWithFooterButtons(
            title,
            message,
            'info',
            [
                {
                    label: 'OK',
                    class: 'swal2-confirm swal2-styled',
                    onClick: callback || (() => { })
                }
            ]
        );
    }

    //  Delete Confirmation
    confirmWarning(itemTitile: string, itemName: string, onConfirm: () => void, onCancel?: () => void) {
        let button: any;
        if(itemTitile == 'Unlock Confirmation') {
            button = 'Unlock';
        } else if(itemTitile == 'Lock Confirmation'){
            button = 'Lock';
        } else {
            button = 'Yes';
        }
        this.alertWithFooterButtons(
            `${itemTitile}`,
            `${itemName}`,
            'question',
            [
                {
                    label: button,
                    class: 'swal2-confirm swal2-styled',
                    onClick: onConfirm
                },
                {
                    label: 'Cancel',
                    class: 'swal2-cancel swal2-styled',
                    onClick: onCancel || (() => { })
                }
            ]
        );
    }
}
